import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import Checkbox from '@mui/material/Checkbox'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import AutocompleteFetch from '@/javascript/presentation/components/inputs/autocomplete-fetch-input'
import { ResourcePlaceData } from '@/javascript/presentation/view-models'

type Props = {
  resourcePlaces: ResourcePlaceData[]
  setResourcePlaces: React.Dispatch<React.SetStateAction<ResourcePlaceData[]>>
  fetchResourcePlaces: (searchText?: string) => Promise<ResourcePlaceData[]>
  autocompleteFetchProps?: Partial<React.ComponentProps<typeof AutocompleteFetch>>
  optionsProps?: {
    tooltipTitle: string
    disable?: (option: ResourcePlaceData) => boolean
  }
}

const ResourcePlacesInput: React.FC<Props> = ({
  resourcePlaces, setResourcePlaces, fetchResourcePlaces, autocompleteFetchProps, optionsProps
}) => {
  return (
    <AutocompleteFetch
      label="Clientes ou Locais" value={resourcePlaces} setValue={setResourcePlaces}
      fetchOptions={fetchResourcePlaces}
      renderOption={(renderProps, option: ResourcePlaceData, { selected }) => {
        return (
          <Tooltip key={option.value} title={optionsProps?.tooltipTitle} placement="right" arrow
            disableHoverListener={!optionsProps?.tooltipTitle || !optionsProps?.disable?.(option)}
            slotProps={{
              popper: {
                modifiers: [{ name: 'offset', options: { offset: [0, -30] } }]
              }
            }}
          >
            <span>
              <li {...renderProps}>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.label}
              </li>
            </span>
          </Tooltip>
        );
      }}
      {...autocompleteFetchProps}
    />
  )
}

export default ResourcePlacesInput
